export enum INDEXES {
  STUDY = 'Study',
  PARTICIPANT = 'Participant',
  FILE = 'File',
  BIOSPECIMEN = 'Biospecimen',
  VARIANT = 'Variant',
  GENE = 'Gene',
  PROGRAM = 'Program',
}
